/**
 * File country.js.
 *
 * Handles country list blocks.
 */
(function ($) {
    'use strict';

    let currentAjaxRequest = null;

    $(document).ready(function () {
        let debounceTimer;

        // Load more country
        $(document).on('click', '.country-selector-topics-wise__search-dropdown-item', function () {
            $("#help-site-search-modal").modal('show');
        });

        $(document).on('click', '#help-site-search-modal .class-modal', function () {
            $("#help-site-search-modal").modal('hide');
        });

        // Search for a country
        $(document).on('click', '.country-selector-topics-wise__search-with-country li a', function () {
            let modalItem     = $('.help-home-modal');
            let siteTitlePre  = $(this).attr('data-site-title-pre') ? $(this).attr('data-site-title-pre') : '';
            let siteMainUrl   = $(this).attr('data-site-main-url') ? $(this).attr('data-site-main-url') : '';
            let siteStatus    = $(this).attr('data-site-status') ? $(this).attr('data-site-status') : '';
            let siteStatusMsg = $(this).attr('data-site-status-message') ? $(this).attr('data-site-status-message') : '';
            modalItem.find('.popup-right-side-btn-text').html(siteConfig.go_to_help_site_msg1);
            if ( siteStatus == '1' ) {
                modalItem.find('.modal-language-select-text').hide();
                let redirectingHtml = '<p class="alert alert-warning text-center">' + siteConfig.redirect_message + '</p>';
                modalItem.find('.modal-body-content ul').html(redirectingHtml);
                modalItem.removeClass('site-status-under-maintenance');
                window.location.href = siteMainUrl;
            } if ( siteStatus == '0' ) {
                modalItem.find('.modal-language-select-text').show();
                modalItem.find('.popup-right-side-btn-text').html(siteConfig.go_to_help_site_msg2);
                modalItem.addClass('site-status-under-maintenance');
                modalItem.find('.modal-language-select-text').hide();
                let underMaintenanceHtml = '<p class="site-status-message">' + siteStatusMsg + '</p>';
                modalItem.find('.modal-body-content ul').html(underMaintenanceHtml);
                modalItem.find('.modal-go-to-site-link').prop("href", siteMainUrl + 'global/');
            }
            modalItem.find('.modal-header-title h4').html(siteTitlePre);
        });

        $(".unhcr-search-box").removeClass('country-selector-topics-wise__search-with-active');

        $(document).on('focus', '.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input input', function () {
            let filterItem = $(this).parents('.country-selector-topics-wise__search-with-country');
            let query = $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input input').val();
            let topicName = $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-topic-name') ? $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-topic-name') : '';
            let currentLang = $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-current-lang') ? $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-current-lang') : '';
            
            if ( query.length === 0 ) {
                countryListForSearchAjax( filterItem, query, 'country', topicName, currentLang );
            }

            let filterCouontryItem = $('.country-selector-topics-wise__header-search').find('.country-selector-topics-wise__search-with-language');
            filterCouontryItem.removeClass('country-selector-topics-wise__search-with-active');
            filterCouontryItem.find('.country-selector-topics-wise__search-dropdown ul').html('');
            filterCouontryItem.find('input').val('');
        });
        
        $(document).on('keyup', '.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input input', function () {
            let query = $(this).val();
            let filterItem = $(this).parents('.country-selector-topics-wise__search-with-country');
            let topicName = $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-topic-name') ? $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-topic-name') : '';
            let currentLang = $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-current-lang') ? $('.country-selector-topics-wise__search-with-country .country-selector-topics-wise__search-input').attr('data-current-lang') : '';
            if ( query.length > 0 ) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(function () {
                    countryListForSearchAjax( filterItem, query, 'country', topicName, currentLang );
                }, 500); // adjust delay as needed
            } else if ( query.length === 0 ) {
                filterItem.removeClass('country-selector-topics-wise__search-with-active');
                filterItem.find('.country-selector-topics-wise__search-dropdown ul').html('');
            }
        });

        $(document).on('click', '.country-selector-topics-wise__search-with-active .search-submit-button', function () {
            let filterItem = $(this).parents('.country-selector-topics-wise__search-with-country');
            filterItem.removeClass('country-selector-topics-wise__search-with-active');
            filterItem.find('.country-selector-topics-wise__search-dropdown ul').html('');
            filterItem.find('input').val('');
        });
    });

    // Ajax For Country List Block
    function countryListForSearchAjax( filterItem, query, searchBy, topicName, currentLang ) {
        filterItem.addClass('country-selector-topics-wise__search-loader');
        filterItem.find('.country-selector-topics-wise__search-dropdown ul').html('');

        if (currentAjaxRequest && currentAjaxRequest.readyState !== 4) {
            currentAjaxRequest.abort();
        }

        currentAjaxRequest = jQuery.ajax({
            type: 'POST',
            dataType: "json",
            data: {
                action: 'unhcr_country_topics_wise_list_search',
                ajax_nonce: siteConfig.ajax_nonce,
                search_query: query,
                search_by: searchBy,
                topic_name: topicName,
                current_lang: currentLang,
            },
            url: siteConfig.ajaxUrl,
            success: function (countryData) {
                let countryListObj = countryData.data.result_country;

                if ( countryListObj && 0 < countryListObj.length ) {
                    filterItem.find('.country-selector-topics-wise__search-dropdown').show();
                    filterItem.addClass('country-selector-topics-wise__search-with-active');
                    filterItem.find('.country-selector-topics-wise__search-dropdown ul').html('');

                    $.each( countryListObj, function ( key, item ) {
                        let countryItem = document.createElement('li');

                        let countryLink = document.createElement('a');
                        countryLink.setAttribute('href', '#');
                        countryLink.setAttribute('class', 'country-selector-topics-wise__search-dropdown-item');
                        countryLink.setAttribute('data-site-title-pre', item.site_title_pre);
                        countryLink.setAttribute('data-site-main-url', item.hs_site_url_main);
                        countryLink.setAttribute('data-site-status', item.help_site_status);
                        countryLink.setAttribute('data-site-status-message', item.status_message);

                        let countryFlagImg = document.createElement('img');
                        countryFlagImg.setAttribute('src', item.img_url);
                        countryFlagImg.setAttribute('alt', 'Flag: ' + item.title);
                        countryFlagImg.setAttribute('decoding', 'async');
                        countryFlagImg.setAttribute('width', '32');
                        countryFlagImg.setAttribute('height', '32');

                        let countryItemText = document.createElement('p');
                        countryItemText.setAttribute('class', 'country-selector-topics-wise__search-country-dropdown-item-text');

                        let countryName = document.createElement('span');
                        countryName.setAttribute('class', 'country-selector-topics-wise__search-dropdown-item-text-name');
                        countryName.innerHTML = item.title;

                        let countryLanguageCode = document.createElement('span');
                        countryLanguageCode.setAttribute('class', 'country-selector-topics-wise__search-dropdown-item-text-code');
                        countryLanguageCode.innerHTML = item.languages;

                        countryItemText.appendChild(countryName);
                        countryItemText.appendChild(countryLanguageCode);

                        countryLink.appendChild(countryFlagImg);
                        countryLink.appendChild(countryItemText);

                        countryItem.appendChild(countryLink);

                        filterItem.find( '.country-selector-topics-wise__search-dropdown ul' ).append( countryItem );
                    })
                } else {
                    filterItem.find('.country-selector-topics-wise__search-dropdown').hide();
                }
                filterItem.removeClass('country-selector-topics-wise__search-loader');
            }
        });
    }
})(jQuery);